import { money } from "./rateMath";

export const Section = ({ letter, title, description, children, testId }) => (
  <div className="p-4 rounded-lg border border-gray-100 bg-white" data-testid={testId}>
    <div className="flex items-baseline gap-2">
      <span className="text-[10px] font-semibold text-pink-600">{letter}</span>
      <div className="text-sm font-medium text-gray-800">{title}</div>
    </div>
    {description && <p className="text-xs text-gray-500 mt-1 mb-3">{description}</p>}
    {children}
  </div>
);

export const CostFrequencies = ({ result }) => {
  const rows = [
    ["Daily", result.total / 365],
    ["Weekly", result.total / 52],
    ["Monthly", result.total / 12],
    ["Yearly", result.total],
  ];
  return (
    <Section letter="A" title="Break-even cost across all frequencies" description={`What your ${money(result.trueHourly)}/hr true cost adds up to — the wages + overhead you must recover.`} testId="rate-calc-cost-frequencies">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {rows.map(([label, v]) => (
          <div key={label} className="rounded-md bg-gray-50 px-3 py-2">
            <div className="text-[11px] text-gray-500">{label}</div>
            <div className="font-mono text-sm font-semibold text-gray-900" data-testid={`cost-freq-${label.toLowerCase()}`}>{money(v)}</div>
          </div>
        ))}
      </div>
    </Section>
  );
};
